import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useLayoutEffect,
} from 'react';
import { Table } from 'react-virtualized';
import debounce from 'lodash/debounce';
import unescape from 'lodash/unescape';
import clamp from 'lodash/clamp';
import { timeToSecond, secondToTime } from 'utils';
import Button from 'components/Button';
import Tooltip from 'components/Tooltip';

import { FiTrash2, FiPlus } from 'react-icons/fi';

import { Subtitle } from './styles';

export default function({
  player,
  subtitles,
  addSubtitle,
  currentIndex,
  updateSubtitle,
  removeSubtitle,
  translateSubtitle,
  checkSubtitle,
}) {
  let isDroging = false;
  let lastPageX = 0;
  let lastSub = null;
  let lastKey = '';
  let lastValue = '';

  // const ref = useRef()

  function onMouseDown(event, sub, key) {
    isDroging = true;
    lastPageX = event.pageX;
    lastSub = sub;
    lastKey = key;
  }

  function onMouseMove(event, sub, key) {
    if (isDroging) {
      const time = Number(((event.pageX - lastPageX) / 10).toFixed(3));
      lastValue = secondToTime(
        clamp(timeToSecond(sub[key]) + time, 0, Infinity),
      );
    }
  }

  // const [keyPress, setKeyPress] = useState(null)

  function useRunAfterUpdate() {
    const afterPaintRef = useRef(null);
    useLayoutEffect(() => {
      if (afterPaintRef.current) {
        afterPaintRef.current();
        afterPaintRef.current = null;
      }
    });
    const runAfterUpdate = fn => (afterPaintRef.current = fn);
    return runAfterUpdate;
  }

  const runAfterupdate = useRunAfterUpdate();
  const textareaRef = useRef();
  function autoBreakLine(event, rowData) {
    const target = event.target;
    let cursorPos = event.target.selectionStart;
    let sub = event.target.value;

    if (sub.split('\n').length > 2) {
      // Não permite adicionar mais de um enter por sub, se as linhas pós-enter
      // juntas excederem 32 chars
      if (sub.split('\n')[1].length + sub.split('\n')[2].length > 42) {
        return;
      } else {
        // Considera apenas o primeiro enter.
        // Se der enter na segunda linha, será desconsiderado
        sub = `${sub.split('\n')[0]}\n${sub.split('\n')[1]}${
          sub.split('\n')[2]
        }`;
      }
    }
    if (sub.split('\n')[0].length > 42) {
      // Se tentou digitar um caracter, mas excedeu 32 caracteres
      // Procura o último espaço antes de 32 caracteres
      // e o substitui por um enter.
      sub =
        sub.slice(0, 42).slice(0, sub.lastIndexOf(' ')) +
        '\n' +
        sub
          .slice(sub.slice(0, 42).slice(0, sub.lastIndexOf(' ')).length)
          .replace('\n', '');

      if (cursorPos === 43) cursorPos++;
    }
    sub = sub.replace('  ', ' ').replace('  ', ' ');
    // // Não permite adicionar mais de um enter por sub
    // if (event.target.value.split('\n').length > 2) return;
    // if (sub.split('\n')[0].length > 32) {
    //   sub = `${sub.slice(0, 32).replace(/\n/g, '')}\n${sub
    //     .slice(32)
    //     .replace(/\n/g, '')}`;
    //   // Se a primeira linha tiver mais de 33 caracteres, manda o 33o para a segunda linha
    //   if (cursorPos === 33) cursorPos++;
    // }
    updateSubtitle(rowData, 'text', sub);
    runAfterupdate(() => {
      // atualiza a posição do cursor
      target.setSelectionRange(cursorPos, cursorPos);
    });
  }

  const onMouseUp = useCallback(() => {
    if (isDroging) {
      if (lastSub && lastKey && lastValue) {
        updateSubtitle(lastSub, lastKey, lastValue);
      }
      isDroging = false;
      lastPageX = 0;
      lastSub = null;
      lastKey = '';
      lastValue = '';
    }
  }, []);

  const [width, setWidth] = useState(100);
  const [height, setHeight] = useState(100);

  const resize = useCallback(() => {
    setWidth(document.body.clientWidth / 2);
    setHeight(document.body.clientHeight - 210);
  }, [setWidth, setHeight]);

  useEffect(() => {
    resize();
    if (!resize.init) {
      resize.init = true;
      const debounceResize = debounce(resize, 500);
      window.addEventListener('resize', debounceResize);
    }
  }, [resize]);

  return (
    <Subtitle>
      <Table
        headerHeight={40}
        width={width}
        height={height}
        rowHeight={80}
        scrollToIndex={currentIndex}
        rowCount={subtitles.length}
        rowGetter={({ index }) => subtitles[index]}
        headerRowRenderer={() => null}
        rowRenderer={props => {
          return (
            <div
              key={props.key}
              className={[
                props.className,
                props.index % 2 ? 'odd' : '',
                currentIndex === props.index ? 'highlight' : '',
                checkSubtitle(props.rowData) ? 'illegal' : '',
              ]
                .join(' ')
                .trim()}
              style={props.style}
              onClick={() => {
                player.pause = true;
                if (player.duration >= props.rowData.startTime) {
                  player.seek = props.rowData.startTime + 0.001;
                }
              }}
            >
              <div className="row operation" style={{ width: 30 }}>
                <i
                  className="icon-trash-empty"
                  onClick={() => removeSubtitle(props.rowData)}
                  style={{ marginBottom: 5 }}
                />

                <Button
                  fill
                  color="font"
                  round="true"
                  onClick={() => removeSubtitle(props.rowData)}
                  id={`id_button_trash${props.index}`}
                >
                  <FiTrash2 />
                </Button>
                <Tooltip target={`id_button_trash${props.index}`}>
                  DELETAR
                </Tooltip>

                <Button
                  fill
                  color="font"
                  round="true"
                  onClick={() => addSubtitle(props.index + 1)}
                  id={`id_button_edit${props.index}`}
                >
                  <FiPlus />
                </Button>
                <Tooltip target={`id_button_edit${props.index}`}>
                  ADICIONAR ABAIXO
                </Tooltip>
              </div>
              <div
                className="row time"
                style={{ width: 150 }}
                onMouseUp={onMouseUp}
              >
                <div
                  className="input"
                  onMouseDown={event =>
                    onMouseDown(event, props.rowData, 'start')
                  }
                  onMouseMove={event =>
                    onMouseMove(event, props.rowData, 'start')
                  }
                  style={{ marginBottom: 10 }}
                >
                  {props.rowData.start}
                </div>
                <div
                  className="input"
                  onMouseDown={event =>
                    onMouseDown(event, props.rowData, 'end')
                  }
                  onMouseMove={event =>
                    onMouseMove(event, props.rowData, 'end')
                  }
                >
                  {props.rowData.end}
                </div>
              </div>
              <div className="row duration" style={{ width: 70 }}>
                {props.rowData.duration}
              </div>
              <div className="row text" style={{ flex: 1 }}>
                <textarea
                  ref={textareaRef}
                  maxLength={84}
                  spellCheck={false}
                  className="textarea"
                  value={unescape(props.rowData.text)}
                  // onKeyPressCapture={e => {
                  //   setKeyPress(e.keyCode)
                  // }}
                  onChange={e => autoBreakLine(e, props.rowData)}
                />
              </div>
            </div>
          );
        }}
      />
    </Subtitle>
  );
}
